import React from 'react';
import { Box, HStack, Menu, MenuButton, MenuList, MenuItem, Input, Button, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import useTicketMap from '../../hooks/useTicketMap';
import { MapView } from '../../GlobalComponent/MapView/MapView';
import { ColorLegend } from '../../GlobalComponent/ColorLegend/ColorLegend';
import { Company } from '../../Interfaces/Company';
import { LocationLabel, LocationColor } from '../../Interfaces/Map';

interface TicketMapProps {
  companies: Company[];
  isActive?: boolean;
}

const TicketMap: React.FC<TicketMapProps> = ({ companies, isActive = true }) => {
  const {
    loading,
    filteredCompanies,
    selectedCompanyName,
    clusters,
    setSelectedCompany,
    searchTerm,
    setSearchTerm,
    isOpen,
    setIsOpen,
    inputRef,
    isTicketMode,
    setIsTicketMode,
  } = useTicketMap({ companies });

  return (
    <Box width={"98%"}>
      <HStack spacing={4} mb={4} align="start">
        <RadioGroup value={isTicketMode ? "ticket" : "doctor"} onChange={(value) => setIsTicketMode(value === "ticket")} height="40px">
          <Stack direction="row" spacing={4} height="100%" align="center">
            <Radio value="ticket">Ticket Raised</Radio>
            <Radio value="doctor">Doctor Consult</Radio>
          </Stack>
        </RadioGroup>

        <Menu isOpen={isOpen} onClose={() => setIsOpen(false)}>
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            onClick={() => setIsOpen(!isOpen)}
            width="300px"
            textAlign="left"
          >
            {selectedCompanyName || "Select a company"}
          </MenuButton>
          <MenuList maxH="300px" overflowY="auto">
            <Box p={2} onClick={(e) => e.stopPropagation()}>
              <Input
                ref={inputRef}
                placeholder="Search companies..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setTimeout(() => inputRef.current?.focus(), 0);
                }}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    e.preventDefault();
                  }
                }}
                onFocus={(e) => e.stopPropagation()}
                size="sm"
                autoComplete="off"
              />
            </Box>
            {filteredCompanies.map((company) => (
              <MenuItem
                key={company._id}
                onClick={() => {
                  setSelectedCompany(company._id);
                  setSearchTerm("");
                  setIsOpen(false);
                }}
              >
                {company.companyName}
              </MenuItem>
            ))}
            {filteredCompanies.length === 0 && (
              <MenuItem isDisabled>
                No companies found
              </MenuItem>
            )}
          </MenuList>
        </Menu>
        <ColorLegend items={[
          { color: LocationColor.TICKET, label: LocationLabel.TICKET },
          { color: LocationColor.DOCTOR_CONSULT, label: LocationLabel.DOCTOR_CONSULT },
        ]} />
      </HStack>

      {!loading ? <MapView clusters={clusters} isActive={isActive} /> : <Box p={4}>Loading map data...</Box>}
    </Box >
  );
};

export default TicketMap;